import { TransaksiKas } from './TransaksiKasPage'

export default function KasKeluar() {
  return <TransaksiKas jenis="keluar" />
}
